import React from "react";
import { Grid, Typography, CircularProgress } from "@material-ui/core";

const Loading: React.FC = () => {
  return (
    <React.Fragment>
      <Grid
        container
        alignItems="center"
        justify="center"
        spacing={2}
        direction="column"
      >
        <Grid item>
          <CircularProgress />
        </Grid>
        <Grid item>
          <Typography>Loading survey</Typography>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default Loading;
